import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-functionality',
  templateUrl: './payment-functionality.component.html',
  styleUrls: ['./payment-functionality.component.css']
})
export class PaymentFunctionalityComponent implements OnInit {

  @Input() transferURL: string;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.activeModal.close();
  }

}
